import { create } from "zustand";
import { Invoice, InvoiceSearchParams } from "../../types";

interface InvoiceDisputeState {
  invoices: Invoice[];
  setInvoices: (invoices: Invoice[]) => void;
  loading: boolean;
  invoicesLoaded: boolean;
  setInvoicesLoaded: (loaded: boolean) => void;
}

const generateInvoicesSet = ({invoicesLoadedInitial = false} = {}) => (set: any) => ({
  invoices: [],
  loading: true,
  setInvoices: (invoices: Invoice[]) => set({ invoices, loading: false }),
  invoicesLoaded: invoicesLoadedInitial,
  setInvoicesLoaded: (invoicesLoaded: boolean) => set({ invoicesLoaded }),
})

export const useInvoices = create<InvoiceDisputeState>(generateInvoicesSet());


interface InvoicesSearchParamsState {
  invoiceSearchParams: InvoiceSearchParams | null;
  setInvoiceSearchParams: (invoiceSearchParams: InvoiceSearchParams) => void;
  activePage: number;
  setActivePage: (activePage: number) => void;
}

const invoiceSearchParamsStateSet = (set: any) => ({
    invoiceSearchParams: null,
    setInvoiceSearchParams: (invoiceSearchParams: InvoiceSearchParams) => set({ invoiceSearchParams }),
    activePage: 1,
    setActivePage: (activePage: number) => set({ activePage }),
  });

export const useInvoiceSearchParams = create<InvoicesSearchParamsState>(invoiceSearchParamsStateSet);